module.exports = __webpack_public_path__ + "static/contact-buena-d9571cd213d2d849406adf532d598734.jpg";